import { createPortal } from 'react-dom';
import type { Dashboard } from '@pixerito/api-client';
import { buildCsv, downloadFile, exportFileName, printReport, reportTitle } from '../lib/export';
import { usePopover } from '../lib/usePopover';
import { Icon } from './ui';

/**
 * Botão "Exportar" do dashboard: baixa as análises do período que está na tela como planilha (CSV) ou abre a
 * impressão do navegador, onde "Salvar como PDF" gera o relatório (o visual de papel vem do CSS de impressão).
 */
export function ExportMenu({ data }: { data: Dashboard }) {
  const { open, position, triggerRef, popoverRef, toggle, close } = usePopover({ width: 300, estimatedHeight: 150 });
  const csv = buildCsv(data);

  function exportSheet() {
    close(true);
    if (csv) downloadFile(exportFileName(data, 'csv'), csv, 'text/csv');
  }

  function exportPdf() {
    close(false);
    // Espera o painel sair da tela para a impressão não pegar o menu.
    window.requestAnimationFrame(() => printReport(reportTitle(data)));
  }

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="btn btn--ghost export-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={!csv}
        onClick={toggle}
      >
        <Icon name="download" size={16} />
        Exportar
      </button>

      {open &&
        position &&
        createPortal(
          <div
            ref={popoverRef}
            className="period-pop export-pop"
            role="menu"
            aria-label="Exportar análises"
            tabIndex={-1}
            style={{ top: position.top, left: position.left, width: position.width, maxHeight: position.maxHeight }}
          >
            <button type="button" role="menuitem" onClick={exportSheet}>
              <b>Planilha (CSV)</b>
              <small>Todos os números do período, para abrir no Excel ou no Google Planilhas.</small>
            </button>
            <button type="button" role="menuitem" onClick={exportPdf}>
              <b>PDF</b>
              <small>Abre a impressão: escolha “Salvar como PDF” como destino.</small>
            </button>
          </div>,
          document.body,
        )}
    </>
  );
}
